const Star = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M15.1701 4.31026L15.1105 7.53625C15.102 7.97887 15.383 8.56621 15.7405 8.83008L17.8514 10.4303C19.2048 11.4517 18.9835 12.703 17.3662 13.2137L14.6169 14.0734C14.1572 14.2181 13.6721 14.7203 13.5529 15.1885L12.8975 17.6909C12.3782 19.6657 11.0844 19.8615 10.0119 18.1251L8.51381 15.6992C8.24143 15.2565 7.59453 14.9246 7.08382 14.9501L4.24087 15.0948C2.20653 15.197 1.62771 14.0223 2.95557 12.4732L4.64091 10.5154C4.95585 10.1494 5.10055 9.46846 4.95584 9.00882L4.09618 6.25947C3.59398 4.6422 4.49623 3.74847 6.10498 4.2762L8.616 5.10186C9.0416 5.23805 9.67998 5.14441 10.0375 4.88054L12.6592 2.9909C14.0721 1.96947 15.2042 2.56532 15.1701 4.31026Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.102 19.5127L16.5229 16.9336"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Star;
